import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classNames from 'classnames'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import ListSubHeader from '@material-ui/core/ListSubheader'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { withStyles } from '@material-ui/core/styles'

import {
  Add as AddIcon,
  Save as SaveIcon,
  Email as EmailIcon,
  CloudDownload as CloudDownloadIcon,
} from '@material-ui/icons'

import {
  getCasting,
  editCasting,
  editCastingProfile,
  editCastingProfiles,
  addManualProfileToCasting,
} from '../actions/castings'
import {
  exportsCastingsCSV,
  exportsCastingsProfilesCSV,
} from '../actions/export'
import {
  triggerEmailParticipants,
} from '../actions/admin'
import {
  ROUTES,
  USER_TYPE,
  ELYTIZ_URL,
  VALIDATION_STATUS,
} from '../constant'
import { getFullName, getConstantKey, getFolioPicture } from '../helpers'
import { getAllUsers } from '../actions/admin'
import { navigateToUserPage } from '../actions/app'
import Avatar from '../components/Avatar'
import Upload from '../components/Upload'
import Loading from '../components/Loading'
import Button from '../components/Button'
import Section from '../components/Section'
import Checkbox from '../components/Checkbox'
import DateField from '../components/DateField'
import Breadcrumb from '../components/Breadcrumbs'
import TableAutomation from '../components/TableAutomation'


const styles = () => ({
  section: {
    flex: 1,
    marginRight: 20,
  },
  url: {
    cursor: 'pointer',
    wordBreak: 'break-all',
  },
  smokeColor: {
    color: 'silver',
  },
  sectionInfo: {
    width: '100%',
    maxWidth: 500,
  },
  whiteContainer: {
    backgroundColor: 'white',
  },
  modalContainer: {
    padding: 30,
    width: '90vw',
    maxWidth: '1166px',
    backgroundColor: 'white',
  },
  gridRoot: {
    marginTop: 10,
    marginRight: 10,
    display: 'flex',
    paddingBottom: 12,
    background: 'white',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderTop: '1px solid whitesmoke',
  },
  gridList: {
    /*
    width: 380,
    height: 200,
    overflowY: 'auto',

    '& > nth-child(odd)': {
      marginRight: 0,
    },
    */
    width: '100%',
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  infoSubtitle: {
    display: 'block',
  },
  gridHeader: {
    width: '100%',
    display: 'flex',
    paddingBottom: 10,
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'space-between',
  },
  gridName: {
    flex: 1,
    overflow: 'hidden',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  gridListTile: {
    height: 180,
    width: '100%',
    cursor: 'pointer',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  dropSection: {
    marginTop: 20,
    borderRadius: 3,
    border: '1px solid silver',
  },
  preview: {
    width: 150,
    margin: 10,
    height: 150,
    borderRadius: 3,
    display: 'inline-block',
  },
  avatar: {
    width: 100,
    height: 100,
    borderRadius: 4,
  },
  minAvatar: {
    width: 50,
    height: 50,
  },
})


const Profile = ({
  profile,
  classes,
  onMenuClick,
}) => {
  const noFolio = !Array.isArray(profile.folios) || (Array.isArray(profile.folios) && !profile.folios.length)
  const handleMenuClick = e => onMenuClick(e, profile)

  return (
    <div className={classes.gridRoot}>
      <div className={classes.gridHeader}>
        <Avatar src={profile.thumbnail || profile.picture} className={classes.minAvatar} />
        <ListSubHeader disableSticky className={classes.gridName}>{getFullName(profile)}</ListSubHeader>
        <IconButton className={classes.gridButton} onClick={handleMenuClick}><MoreVertIcon /></IconButton>
      </div>
      <GridList cellHeight={180} className={classes.gridList}>
        {(profile.folios || []).filter(x => !x.is_hidden).filter(f => getFolioPicture(f)).slice(0, 2).map((folio) => {
          const thumbnail = getFolioPicture(folio)
          const picture = getFolioPicture(folio, true)

          return (
            <GridListTile component="a" key={thumbnail} href={picture || thumbnail} target="_blank">
              <div style={{ backgroundImage: `url(${thumbnail}` }} className={classes.gridListTile} />
            </GridListTile>
          )
        })}
      </GridList>
      {noFolio && <ListSubHeader disableSticky>Folio is missing. There is probably no folio or the folio has not been synchronized yet. Try refresh later</ListSubHeader>}
    </div>
  )
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  onMenuClick: PropTypes.func.isRequired,
}


class Casting extends Component {
  /* LIFECYCLE */
  state = {
    type: '',
    name: '',
    email: '',
    subject: '',
    body: '',
    image_url: '',
    is_opened: false,
    is_visible: false,
    description: '',
    display_date: '',
    profileEmail: '',
    casting_date: '',
    display_location: '',
    profileFirstname: '',
    profileLastname: '',
    profileFolio: [],
    initialSelected: [],
    emailToPending: true,
    emailToWaitlist: true,
    emailToRejected: true,
    emailToDismissed: true,
    emailToShortlisted: true,
    anchor: null,
    selected: [],
    profile: null,
    modalOpened: false,
  }

  /**
   * @componentWillMount
   */
  componentWillMount() {
    if (this.props.isConnected) {
      this.props.getCasting(this.props.match.params.id)
    }
  }


  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const {
      match,
      casting,
      location,
      isConnected,
    } = nextProps

    if ((location.pathname !== this.props.location.pathname && isConnected) || (isConnected && !this.props.isConnected)) {
      this.props.getCasting(match.params.id)
    }

    if (casting !== this.props.casting) {
      this.updateSelected(casting)
    }
  }


  /* METHODS */

  handleOpenMenu = (e, profile) => this.setState({
    profile,
    anchor: e.currentTarget,
  })

  handleDrop = (acceptedFiles) => {
    return this.setState({
      profileFolio: acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file),
      })),
    })
  }

  handleCloseMenu = () => this.setState({ anchor: null })

  handleOpenDatabaseModal = () => this.setState({ modalOpened: 'database' })

  handleOpenManualModal = () => this.setState({ modalOpened: 'manual' })

  handleOpenEmailModal = () => this.setState({ modalOpened: 'email' })

  handleCloseModal = () => this.setState({
    body: '',
    subject: '',
    profileFolio: [],
    profileEmail: '',
    profileLastname: '',
    profileFirstname: '',
    modalOpened: false,
    emailToPending: true,
    emailToWaitlist: true,
    emailToRejected: true,
    emailToDismissed: true,
    emailToShortlisted: true,
  })

  handleUserTypeChange = (e) => {
    const { name, value } = e.target

    this.setState({ [name]: value }, () => this.handleGetUsers())
  }

  handleSelectChange = selected => this.setState({ selected })

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleNavigateProfile = () => this.props.navigateToUserPage(this.state.profile.id || this.state.profile.profileId, '_blank')

  createNavigateProfileHandler = user => (e) => {
    e.preventDefault()
    e.stopPropagation()

    this.props.navigateToUserPage(user.objectID, '_blank')
  }

  handleEditCasting = () => {
    const castingData = {
      type: this.state.type,
      name: this.state.name,
      email: this.state.email,
      rate: this.state.rate || '',
      brand: this.state.brand || '',
      duration: this.state.duration || '',
      is_opened: this.state.is_opened || false,
      description: this.state.description || '',
      is_visible: this.state.is_visible || false,
      display_date: this.state.display_date || '',
      casting_date: this.state.casting_date || '',
      display_location: this.state.display_location || '',
      profilesToAdd: this.state.selected.filter(x => !this.state.initialSelected.includes(x)),
      profilesToRemove: this.state.initialSelected.filter(x => !this.state.selected.includes(x)),
    }

    if (this.state.image_url) {
      castingData.image_url = this.state.image_url
    }

    this.props.editCasting(castingData)
  }

  handleRemoveProfile = () => {
    const { profile } = this.state

    this.handleCloseMenu()

    if (profile && (profile.profileId || profile.id)) {
      this.props.editCastingProfiles([], [profile.profileId || profile.id])
    }
  }

  createChangeProfileValidationHandler = validationStatus => () => {
    const { profile } = this.state

    this.handleCloseMenu()
    return this.props.editCastingProfile(profile.id || profile.profileId, {
      validation_status: validationStatus,
    })
  }

  updateSelected = (casting) => {
    if (!casting) {
      return this.setState({ selected: [] })
    }

    const { profiles } = casting

    const selected = Array.isArray(profiles) ? profiles.map(profile => profile.profileId) : []
    return this.setState({
      selected,
      type: casting.type,
      name: casting.name,
      email: casting.email,
      rate: casting.rate,
      brand: casting.brand,
      initialSelected: selected,
      duration: casting.duration,
      image_url: casting.image_url,
      is_opened: casting.is_opened,
      description: casting.description,
      is_visible: casting.is_visible,
      display_date: casting.display_date,
      casting_date: casting.casting_date,
      display_location: casting.display_location,
    }, () => this.handleGetUsers())
  }

  handleGetUsers = (query, options = {}) => {
    const userType = getConstantKey(USER_TYPE, this.state.type)

    if (!userType) {
      return null
    }

    return this.props.getAllUsers(query, {
      ...options,
      tagFilters: [userType, 'validated'],
    })
  }

  handleToggleUser = (profile) => {
    const { selected } = this.state

    return this.setState({
      selected: selected.includes(profile.objectID) ? selected.filter(x => x !== profile.objectID) : selected.concat(profile.objectID)
    })
  }

  handleSelectAllUsers = () => {
    const { items } = this.props.list

    return this.setState({
      selected: this.state.selected
        .concat(items.map(item => item.objectID))
        .filter((item, index, array) => array.findIndex(x => x === item) === index),
    })
  }

  handleSaveManualProfile = () => {
    const {
      profileEmail,
      profileFolio,
      profileLastname,
      profileFirstname,
    } = this.state

    this.props.addManualProfileToCasting({
      email: profileEmail,
      folio: profileFolio,
      lastname: profileLastname,
      firstname: profileFirstname,
    })
    return this.handleCloseModal()
  }

  handleEmailParticipants = () => {
    const {
      body,
      subject,
      emailToPending,
      emailToWaitlist,
      emailToRejected,
      emailToDismissed,
      emailToShortlisted,
    } = this.state
    const { casting } = this.props

    this.props.triggerEmailParticipants({
      body,
      subject,
      emailToPending,
      emailToWaitlist,
      emailToRejected,
      emailToDismissed,
      emailToShortlisted,
      castingId: casting.objectID,
    })
    this.handleCloseModal()
  }

  hasBeenEdited = () => {
    const { casting } = this.props
    const {
      type,
      name,
      rate,
      brand,
      email,
      duration,
      selected,
      image_url,
      is_opened,
      is_visible,
      description,
      display_date,
      casting_date,
      initialSelected,
      display_location,
    } = this.state

    if (!casting) {
      return false
    }

    if (!selected.every(x => initialSelected.includes(x)) || !initialSelected.every(x => selected.includes(x))) {
      return true
    }

    const hasBeenEdited = casting.type !== type
      || casting.rate !== rate
      || casting.name !== name
      || casting.brand !== brand
      || casting.email !== email
      || casting.duration !== duration
      || casting.casting_date !== casting_date
      || casting.display_date !== display_date
      || casting.display_location !== display_location
      || casting.is_visible !== is_visible
      || casting.is_opened !== is_opened
      || casting.description !== description
      || casting.image_url !== image_url

    return hasBeenEdited
      && !!type
      && !!name
      && !!email
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      list,
      classes,
      casting,
      isLoading,
    } = this.props
    const {
      type,
      name,
      rate,
      body,
      email,
      brand,
      anchor,
      subject,
      duration,
      selected,
      image_url,
      is_opened,
      is_visible,
      description,
      modalOpened,
      casting_date,
      display_date,
      profileFolio,
      profileEmail,
      emailToPending,
      emailToRejected,
      emailToWaitlist,
      emailToDismissed,
      emailToShortlisted,
      profileLastname,
      display_location,
      profileFirstname,
      profile: currentProfile,
    } = this.state

    const pending = casting ? casting.profiles.filter(p => p.validation_status === VALIDATION_STATUS.PENDING) : []
    const dismissed = casting ? casting.profiles.filter(p => p.validation_status === VALIDATION_STATUS.DISMISSED) : []
    const shortlisted = casting ? casting.profiles.filter(p => p.validation_status === VALIDATION_STATUS.SHORTLISTED) : []
    const manualSaveable = profileFolio.length > 0 && profileEmail.includes('@') && profileLastname && profileFirstname
    const castingUrl = `${ELYTIZ_URL}/casting/${casting ? casting.objectID : ''}`

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            { label: 'Castings', to: ROUTES.CASTINGS },
            name || 'Casting',
          ]}
        />

        {casting && casting.is_canceled && <Typography className="mt3 mb3" align="center" color="secondary">This casting has been canceled by the client !</Typography>}

        <Grid container direction="row" wrap="nowrap" className={classes.root}>
          <Grid container direction="column" wra="nowrap">
            <Section title="Participants" className={classes.section}>
              <Grid container alignItems="center" justify="center">
                {isLoading && <Loading className="mb3" text="Loading..." />}
              </Grid>

              <ListSubHeader disableSticky>Pending ({pending.length})</ListSubHeader>
              {pending.map(profile => (
                <Profile
                  profile={profile}
                  classes={classes}
                  onMenuClick={this.handleOpenMenu}
                  key={`profile-selected-${profile.objectID}`}
                />
              ))}

              <ListSubHeader disableSticky className="mt3">Shortlisted ({shortlisted.length})</ListSubHeader>
              {shortlisted.map(profile => (
                <Profile
                  profile={profile}
                  classes={classes}
                  onMenuClick={this.handleOpenMenu}
                  key={`profile-selected-${profile.objectID}`}
                />
              ))}

              <ListSubHeader disableSticky className="mt3">Dismissed ({dismissed.length})</ListSubHeader>
              {dismissed.map(profile => (
                <Profile
                  profile={profile}
                  classes={classes}
                  onMenuClick={this.handleOpenMenu}
                  key={`profile-selected-${profile.objectID}`}
                />
              ))}

              <Menu
                keepMounted
                open={!!anchor}
                anchorEl={anchor}
                id="casting-menu"
                onClose={this.handleCloseMenu}
              >
                <MenuItem
                  onClick={this.handleNavigateProfile}
                  disabled={currentProfile && !currentProfile.objectID}
                >
                  See profile
                </MenuItem>
                <MenuItem
                  onClick={this.createChangeProfileValidationHandler(VALIDATION_STATUS.SHORTLISTED)}
                  disabled={currentProfile && currentProfile.validation_status === VALIDATION_STATUS.SHORTLISTED}
                >
                  To Shortlist
                </MenuItem>
                <MenuItem
                  onClick={this.createChangeProfileValidationHandler(VALIDATION_STATUS.DISMISSED)}
                  disabled={currentProfile && currentProfile.validation_status === VALIDATION_STATUS.DISMISSED}
                >
                  To Dismiss
                </MenuItem>
                <MenuItem onClick={this.handleRemoveProfile}>Remove</MenuItem>
              </Menu>
            </Section>
          </Grid>

          <Grid container direction="column" alignItems="center" justify="flex-start" className={classes.sectionInfo}>
            <Section title="Infos" className={classes.sectionInfo}>
              {casting && (
                <>
                  <ListSubHeader disableSticky component="div">Type</ListSubHeader>
                  <RadioGroup
                    name="type"
                    value={type}
                    onChange={this.handleUserTypeChange}
                  >
                    <Grid container alignItems="center" justify="space-between" wrap="nowrap">
                      <FormControlLabel
                        label="Model"
                        color="primary"
                        value={USER_TYPE.MODEL}
                        control={<Radio color="primary" />}
                      />

                      <FormControlLabel
                        color="secondary"
                        label="Photographer"
                        value={USER_TYPE.PHOTOGRAPHER}
                        control={<Radio color="secondary" />}
                      />
                    </Grid>
                  </RadioGroup>
                  <TextField
                    fullWidth
                    name="email"
                    value={email}
                    label="Email"
                    className="mt2"
                    variant="outlined"
                    onChange={this.handleChange}
                  />
                  <TextField
                    fullWidth
                    name="name"
                    value={name}
                    label="Name"
                    className="mt2"
                    variant="outlined"
                    onChange={this.handleChange}
                  />
                  <TextField
                    fullWidth
                    name="brand"
                    value={brand}
                    label="Brand"
                    className="mt2"
                    variant="outlined"
                    onChange={this.handleChange}
                  />

                  <TextField
                    rows={5}
                    fullWidth
                    multiline
                    className="mt2"
                    name="description"
                    variant="outlined"
                    label="Description"
                    value={description}
                    onChange={this.handleChange}
                  />

                  <TextField
                    fullWidth
                    name="rate"
                    value={rate}
                    label="Rate"
                    className="mt2"
                    variant="outlined"
                    onChange={this.handleChange}
                  />
                  <TextField
                    fullWidth
                    name="duration"
                    value={duration}
                    label="Duration"
                    className="mt2"
                    variant="outlined"
                    onChange={this.handleChange}
                  />

                  <TextField
                    fullWidth
                    className="mt2"
                    variant="outlined"
                    name="display_date"
                    value={display_date}
                    label="Date to display"
                    onChange={this.handleChange}
                  />
                  <DateField
                    fullWidth
                    className="mt2"
                    variant="outlined"
                    name="casting_date"
                    value={casting_date}
                    label="Date entered by user"
                    onChange={this.handleChange}
                  />
                  <TextField
                    fullWidth
                    className="mt2"
                    variant="outlined"
                    name="display_location"
                    value={display_location}
                    label="Location to display"
                    onChange={this.handleChange}
                  />

                  <br />
                  <br />
                  <Checkbox
                    name="is_visible"
                    checked={is_visible}
                    label="Is visible for users in the app ?"
                    onChange={this.handleChange}
                  />

                  <br />
                  <Checkbox
                    name="is_opened"
                    checked={is_opened}
                    label="Is it opened for applications in the app ?"
                    onChange={this.handleChange}
                  />

                  <Grid
                    container
                    wrap="nowrap"
                    alignItems="center"
                    className={classNames('mt1', classes.avatarContainer)}
                  >
                    <Upload
                      name="image_url"
                      type="casting"
                      value={image_url}
                      onChange={this.handleChange}
                      component={props => (
                        <Button
                          {...props}
                          fullWidth
                          color="primary"
                          className="mr3"
                          variant="contained"
                        >
                          Upload an image
                        </Button>
                      )}
                    />

                    <Avatar
                      src={image_url || casting.picture}
                      className={classes.avatar}
                    />
                  </Grid>

                  <Grid container wrap="nowrap" className="mt3">
                    <Typography className={classes.smokeColor}>Creation date:</Typography>
                    <Typography className="ml1">{casting.created_at && moment(casting.created_at).format('DD/MM/YYYY')}</Typography>
                  </Grid>

                  <Grid container wrap="nowrap" className="mt2">
                    <Typography className={classes.smokeColor}>Client edition date:</Typography>
                    <Typography className="ml1">{casting.updated_at ? moment(casting.updated_at).format('DD/MM/YYYY') : 'No edition'}</Typography>
                  </Grid>

                  <Grid container wrap="nowrap" className="mt2">
                    <Typography className={classes.smokeColor}>URL:</Typography>
                    <Typography className="ml1">
                      <Link target="_blank" href={castingUrl} className={classes.url}>{castingUrl}</Link>
                    </Typography>
                  </Grid>
                </>
              )}

              <Button
                fullWidth
                color="primary"
                className="mt3"
                variant="contained"
                isLoading={isLoading}
                disabled={!this.hasBeenEdited()}
                onClick={this.handleEditCasting}
              >
                <SaveIcon className="mr3" /> Save Casting Info
              </Button>

              <Button
                fullWidth
                color="primary"
                className="mt3"
                variant="contained"
                isLoading={isLoading}
                onClick={this.handleOpenManualModal}
              >
                <AddIcon className="mr3" /> Add manually
              </Button>
              <Button
                fullWidth
                color="primary"
                className="mt3"
                variant="contained"
                disabled={!casting}
                isLoading={isLoading}
                onClick={this.props.exportsCastingsProfilesCSV}
              >
                <CloudDownloadIcon className="mr3" /> Export CSV
              </Button>

              <Button
                fullWidth
                color="primary"
                className="mt3"
                variant="contained"
                isLoading={isLoading}
                onClick={this.handleOpenEmailModal}
              >
                <EmailIcon className="mr3" /> Send email to participants
              </Button>
            </Section>

          </Grid>
        </Grid>

        <Dialog
          open={modalOpened === 'email'}
          onClose={this.handleCloseModal}
          classes={{ paper: classes.whiteContainer }}
        >
          <DialogTitle>Send email to participants</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              className="mt2"
              variant="outlined"
              label="Subject"
              name="subject"
              value={subject}
              onChange={this.handleChange}
            />
            <TextField
              fullWidth
              multiline
              rows={3}
              className="mt2"
              variant="outlined"
              label="Body"
              name="body"
              value={body}
              onChange={this.handleChange}
            />

            <br />

            <Checkbox
              name="emailToPending"
              checked={emailToPending}
              onChange={this.handleChange}
              label="Pending users"
            />

            <br />

            <Checkbox
              name="emailToShortlisted"
              checked={emailToShortlisted}
              onChange={this.handleChange}
              label="Shortlisted users"
            />

            <br />

            <Checkbox
              name="emailToDismissed"
              checked={emailToDismissed}
              onChange={this.handleChange}
              label="Dismissed users"
            />

            <br />

            <Checkbox
              name="emailToRejected"
              checked={emailToRejected}
              onChange={this.handleChange}
              label="Rejected users"
            />

            <br />

            <Checkbox
              name="emailToWaitlist"
              checked={emailToWaitlist}
              onChange={this.handleChange}
              label="Waitlist"
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={this.handleEmailParticipants}
              disabled={!body || !subject || (!emailToDismissed && !emailToShortlisted && !emailToPending)}
            >
              Send
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          onClose={this.handleCloseModal}
          open={modalOpened === 'manual'}
          classes={{ paper: classes.whiteContainer }}
        >
          <DialogTitle>Add a participant manually</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              className="mt2"
              variant="outlined"
              label="First name"
              name="profileFirstname"
              value={profileFirstname}
              onChange={this.handleChange}
            />
            <TextField
              fullWidth
              className="mt2"
              variant="outlined"
              label="Last name"
              name="profileLastname"
              value={profileLastname}
              onChange={this.handleChange}
            />
            <TextField
              fullWidth
              className="mt2"
              variant="outlined"
              label="Email"
              name="profileEmail"
              value={profileEmail}
              onChange={this.handleChange}
            />

            <Dropzone
              multiple
              accept="image/*"
              onDrop={this.handleDrop}
            >
              {({ getRootProps, getInputProps }) => (
                <section className={classes.dropSection}>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <ListSubHeader disableSticky>Drag 'n' drop some files here, or click to select files</ListSubHeader>
                  </div>
                  <aside>
                    {profileFolio.map(f => (
                      <img
                        alt="folio"
                        src={f.preview}
                        key={f.preview}
                        className={classes.preview}
                      />
                    ))}
                  </aside>
                </section>
              )}
            </Dropzone>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              disabled={!manualSaveable}
              onClick={this.handleSaveManualProfile}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>


        <Section title="Add participants from database" className={classes.section}>
          <TableAutomation
            selectable
            selected={selected}
            isLoading={isLoading}
            title="List of Users"
            request={this.handleGetUsers}
            onClick={this.handleToggleUser}
            onSortChange={this.handleSortChange}
            onSelectAll={this.handleSelectAllUsers}
            head={[
              '',
              { label: 'Name', sort: 'lastname' },
              { label: 'Email', sort: 'email' },
              { label: 'Registration date', sort: 'created_at' },
              '',
            ]}
            row={user => [
              { display: <Avatar sizes="big" src={user.picture} /> },
              getFullName(user),
              user.email,
              user.created_at ? moment(user.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A',
              { display: <Button variant="contained" color="primary" onClick={this.createNavigateProfileHandler(user)}>View</Button> },
            ]}
            {...list}
          />
        </Section>
      </div>
    )
  }
}


Casting.propTypes = {
  list: PropTypes.object,
  isLoading: PropTypes.bool,
  casting: PropTypes.object,
  isConnected: PropTypes.bool,
  match: PropTypes.object.isRequired,
  getAllUsers: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  getCasting: PropTypes.func.isRequired,
  editCasting: PropTypes.func.isRequired,
  navigateToUserPage: PropTypes.func.isRequired,
  exportsCastingsCSV: PropTypes.func.isRequired,
  editCastingProfile: PropTypes.func.isRequired,
  editCastingProfiles: PropTypes.func.isRequired,
  triggerEmailParticipants: PropTypes.func.isRequired,
  addManualProfileToCasting: PropTypes.func.isRequired,
  exportsCastingsProfilesCSV: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  list: state.list,
  isLoading: state.app.isLoading,
  casting: state.castings.casting,
  isConnected: state.user.isConnected,
})


export default connect(mapStateToProps, {
  getAllUsers,
  getCasting,
  editCasting,
  navigateToUserPage,
  exportsCastingsCSV,
  editCastingProfile,
  editCastingProfiles,
  triggerEmailParticipants,
  addManualProfileToCasting,
  exportsCastingsProfilesCSV,
})(withStyles(styles)(Casting))
